import api from "../axiosConfig"
const qs = require("qs")
const resource = "/salas"

function getDefaultParams(page, pageSize) {
  return {
    "sort[0]": "nome",
    "populate[responsavel]": "*",
    "populate[bloco]": "*",
    "pagination[page]": `${page}`,
    "pagination[pageSize]": `${pageSize}`,
  }
}

function generateFilter(fields, params) {
  let filters = {}
  const conditions = []

  for (const [key, value] of Object.entries(fields)) {
    const newCondition = getFilterCondition(key, value)
    if (newCondition) conditions.push(newCondition)
  }

  if (Object.keys(fields).length > 1) {
    filters["$and"] = conditions
  } else {
    filters = { ...conditions[0] }
  }

  const query = qs.stringify(
    { filters: filters, ...params },
    {
      encodeValuesOnly: true,
    }
  )
  return query
}

function getFilterCondition(field, value) {
  const equipamentos = {}
  switch (field) {
    case "nome":
      return { nome: { $containsi: value } }
    case "andar":
      return { andar: { $eq: value } }
    case "capacidade":
      return { capacidade: { $gte: Number(value) } }
    case "computadores":
      return { computadores: { $gte: Number(value) } }
    case "disponibilidade":
      if (value === true || value === false) {
        return { disponivel: { $eq: value } }
      }
      break
    case "bloco": {
      return {
        bloco: { id: { $eq: value } },
      }
    }
    case "equipamentos":
      for (const equipamento of value) {
        equipamentos[equipamento.replaceAll(" ", "").toLowerCase()] = true
      }
      return equipamentos
  }
}

export default {
  get(page, pageSize) {
    return api.get(`${resource}`, {
      params: getDefaultParams(page, pageSize),
    })
  },
  searchBy(page, pageSize, fields = {}) {
    const params = getDefaultParams(page, pageSize)
    const query = generateFilter(fields, params)
    return api.get(`${resource}/?${query}`)
  },
  getOne(id) {
    return api.get(`${resource}/${id}`, {
      params: {
        "populate[reservas][populate][0]": "dias",
        "populate[reservas][populate][1]": "responsavel",
        "populate[responsavel]": "*",
        "populate[bloco]": "*",
      },
    })
  },
  getSalasComReservas(page, pageSize, fields = {}) {
    const params = {
      "populate[reservas][populate][0]": "dias",
      "populate[reservas][populate][1]": "responsavel",
      ...getDefaultParams(page, pageSize),
    }
    const query = generateFilter(fields, params)

    return api.get(`${resource}/?${query}`)
  },
  create(payload) {
    return api.post(`${resource}`, payload)
  },
  update(id, payload) {
    return api.put(`${resource}/${id}`, payload)
  },
  delete(id) {
    return api.delete(`${resource}/${id}`)
  },
  disponiveis({
    capacidade,
    bloco,
    andar,
    computadores,
    equipamentos,
    dataDeInicio,
    dataDeTermino,
    horarioDeInicio,
    horarioDeTermino,
    dias,
  }) {
    return api.get(`${resource}/disponiveis`, {
      params: {
        capacidade,
        bloco,
        andar,
        computadores,
        equipamentos,
        dataDeInicio,
        dataDeTermino,
        horarioDeInicio,
        horarioDeTermino,
        dias,
      },
    })
  },
}
